// Utility functions and label maps for quiz question types
export function splitType(type: string) {
  const [format = "", marks = "", category = ""] = type.split("-");
  return { format, marks, category };
}

export function joinType(format: string, marks: string, category: string) {
  return [format, marks, category].filter(Boolean).join("-");
}

export function getValidTypeParts(
  questionTypes: string[],
  selected: { format?: string; marks?: string; category?: string },
) {
  const formats = new Set<string>();
  const marks = new Set<string>();
  const categories = new Set<string>();
  questionTypes.forEach((type) => {
    const [f, m, c] = type.split("-");
    if (
      (!selected.marks || m === selected.marks) &&
      (!selected.category || c === selected.category)
    ) {
      formats.add(f);
    }
    if (
      (!selected.format || f === selected.format) &&
      (!selected.category || c === selected.category)
    ) {
      marks.add(m);
    }
    if (
      (!selected.format || f === selected.format) &&
      (!selected.marks || m === selected.marks)
    ) {
      categories.add(c);
    }
  });
  return {
    formats: Array.from(formats),
    marks: Array.from(marks),
    categories: Array.from(categories),
  };
}

export const formatLabels: Record<string, string> = {
  mcq: "Multiple Choice",
  description: "Descriptive",
};
export const marksLabels: Record<string, string> = {
  "1mark": "Short (1 Mark)",
  "2marks": "Medium (2 Marks)",
  "4marks": "Long (4 Marks)",
};
export const categoryLabels: Record<string, string> = {
  memory: "Memory Based",
  analytical: "Analytical",
  scenario: "Scenario Based",
};
